// The daily card session's learning rules as data (Axel's decisions of 2026-10-07, from the second
// research pass; docs/PEDAGOGY.md §1.1, §1.2 and "Card session rules" there). Read by lib/fsrs.ts
// (the relearning cap), lib/session.ts (evening new words, morning recall) and study/StudySession.tsx
// (retrieve to criterion, show then test).
import type { CardType } from '@valyrio/engine/types';

/**
 * Successive relearning (Rawson, Dunlosky & Sciartelli 2013: relearning to criterion in three or
 * more separate sessions gives durable retention). A new word's card is due again within
 * `maxIntervalDays` until it has been recalled correctly (graded Vaikea or better) on `days`
 * different local days; only then does FSRS's own interval apply. FSRS's stability and difficulty
 * are never changed — only the due date is brought forward, so FSRS sees early reviews, which it
 * models honestly (a review at high predicted recall grows stability less).
 */
export const RELEARN = {
  days: 3,
  maxIntervalDays: 1,
  types: ['hv-native', 'native-hv'] as readonly CardType[],
} as const;

/**
 * Retrieve to criterion (Rawson et al. 2013): a card graded Uudelleen comes back later in the same
 * session until it is recalled; FSRS's short learning steps also come back within the session. At
 * most this many re-asks per card per session, so a session always ends (the card then waits in
 * its FSRS learning step for the next session).
 */
export const MAX_REASKS = 3;

/**
 * Evening new words, morning recall (Axel 2026-10-07): new words are offered in the daily session
 * from this local hour on (pace timezone); before it only when started explicitly ("Uudet sanat
 * nyt"), so catch-up is always possible. The next day's session opens with last night's new words.
 */
export const NEW_WORDS_FROM_HOUR = 16;
